import React, { useState, useCallback } from 'react';
import useArticleStore from './stores/useArticleStore';
import { useTranslations } from './contexts/TranslationContext';

var META_DESCRIPTION_MAX = 300;

function parseKeywords(str) {
  if (!str) return [];
  return str.split(',').map(function(s) { return s.trim(); }).filter(Boolean);
}

function joinKeywords(arr) {
  return arr.join(',');
}

export default function SEOPanel({ scheduleAutosave }) {
  var t = useTranslations();
  var metaDescription = useArticleStore(function(s) { return s.meta_description; });
  var metaKeywords = useArticleStore(function(s) { return s.meta_keywords; });
  var updateField = useArticleStore(function(s) { return s.updateField; });

  var inputState = useState('');
  var keywordInput = inputState[0];
  var setKeywordInput = inputState[1];

  var keywords = parseKeywords(metaKeywords);

  var handleDescriptionChange = useCallback(function(e) {
    var value = e.target.value;
    if (value.length <= META_DESCRIPTION_MAX) {
      updateField('meta_description', value);
      scheduleAutosave();
    }
  }, [updateField, scheduleAutosave]);

  var addKeyword = useCallback(function(word) {
    var trimmed = word.trim();
    if (!trimmed) return;
    var current = parseKeywords(metaKeywords);
    if (current.includes(trimmed)) return;
    current.push(trimmed);
    updateField('meta_keywords', joinKeywords(current));
    setKeywordInput('');
    scheduleAutosave();
  }, [metaKeywords, updateField, scheduleAutosave]);

  var removeKeyword = useCallback(function(word) {
    var current = parseKeywords(metaKeywords);
    var updated = current.filter(function(k) { return k !== word; });
    updateField('meta_keywords', joinKeywords(updated));
    scheduleAutosave();
  }, [metaKeywords, updateField, scheduleAutosave]);

  var handleKeyDown = useCallback(function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      addKeyword(keywordInput);
    }
  }, [keywordInput, addKeyword]);

  var charCount = (metaDescription || '').length;

  return (
    <div className="seo-panel">
      <div className="seo-panel__field">
        <label className="form-label small text-muted mb-1">{t.meta_description}</label>
        <div className="form-group">
          <textarea
            className="form-control"
            rows="5"
            value={metaDescription || ''}
            onChange={handleDescriptionChange}
            placeholder={t.meta_description_placeholder}
            maxLength={META_DESCRIPTION_MAX}
          />
          <i className="form-group__bar" />
        </div>
        <div className="seo-panel__counter">
          <span className={charCount >= META_DESCRIPTION_MAX ? 'text-danger' : 'text-muted'}>
            {charCount}/{META_DESCRIPTION_MAX}
          </span>
        </div>
      </div>

      <div className="seo-panel__field">
        <label className="form-label small text-muted mb-1">{t.meta_keywords}</label>
        {keywords.length > 0 && (
          <div className="tags-input__tags mb-2">
            {keywords.map(function(kw) {
              return (
                <span key={kw} className="tags-input__tag">
                  {kw}
                  <button
                    type="button"
                    className="tags-input__tag-remove"
                    onClick={function() { removeKeyword(kw); }}
                  >
                    <i className="zmdi zmdi-close" />
                  </button>
                </span>
              );
            })}
          </div>
        )}
        <div className="form-group">
          <input
            type="text"
            className="form-control"
            value={keywordInput}
            onChange={function(e) { setKeywordInput(e.target.value); }}
            onKeyDown={handleKeyDown}
            placeholder={t.meta_keywords_placeholder}
          />
          <i className="form-group__bar" />
        </div>
      </div>
    </div>
  );
}
